import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import useLogout from "../../hooks/useLogout";
import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
  PreviewAltCard,
  Row,
} from "../../components/Component";
import { Form, Label, Offcanvas, OffcanvasBody, OffcanvasHeader } from "reactstrap";
import MyButton from "../../MyComp/UI/form/MyButton";
import Required from "../../MyComp/UI/form/Required";
import { createPrakritiQuestionAPI, getPrakrityCategoryDDAPI, listPrakrityQuestionsAPI, updatePrakrityQuestionAPI } from "../../api/master/indes";
import Table from "../../MyComp/UI/DataTable/Table";
import { toast } from "react-toastify";

const PrakrityQuestion = () => {
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,

    formState: { errors },
  } = useForm({
    defaultValues: {
      isLoading: false,
      data: [],
    },
  });
  const logout = useLogout();

  const [isOpen, setIsOpen] = useState(false);
  const [mode, setMode] = useState("Add");
  const isLoading = watch("isLoading");
  const [data, setData] = useState([]);
  const [showModal, setShowModal] = useState(false);
   const tableLoading = watch("tableLoading");
  const confirmStatusChange = (data) => {

    const updatedStatus = watch("selectedRow").status === true ? false : true;
    setValue("isLoading", true);
    const formObject = {
      id: watch("selectedRow").id,
      status: updatedStatus,
    };
    updatePrakrityQuestionAPI(formObject)
      .then((res) => {
        //const status = decrypt(res.data.status);
        if (res.data.status === true) {
          toast.success(res.data.message);
          toast.clearWaitingQueue();
          getPrakrityQuestions();
          setIsOpen(false);
          resetF();
          setValue("isLoading", false);
          setShowModal(false);
        } else if (res.data.status === false) {
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };
  const resetF = () => {
    setMode("Add");
    setValue("category_question", null);
    setValue("question_hint", null);
    setValue("question", null);
    setValue("option_one", null);
    setValue("option_two", null);
    setValue("option_three", null);
  };
  const handleToggleStatus = (row) => {
    setValue("selectedRow", row);
    setShowModal(true);
  };

  useEffect(() => {
    getPrakrityQuestions();
  }, []);
  const getPrakrityQuestions = () => {
    setValue("isLoading", true);
    listPrakrityQuestionsAPI()
      .then((res) => {
        if (res.data.status === "expired") {
          setValue("tableLoading", false);
          toast.error(res.data.message);
          logout();
        } else if (res.data.status === true) {
          
          setData(res.data.data || []);
          setValue("tableLoading", false);
        } else {
          setValue("tableLoading", false);
          setData([]);
          toast.error(res.data.message);
        }
      })
      .catch((err) => toast.error(err?.response?.data?.message))
      .finally(() => setValue("isLoading", false));
  };
 
  const toggleCanvas = () => {
    setIsOpen((prev) => !prev);
    if (isOpen) resetF();
  };


  const handleEdit = (row) => {
  window.scrollTo(0, 0);
  setValue("selectedRow", row);
  setIsOpen(true);
  setMode("Edit");


  setValue("category_question", {
    label: row.category_name,
    value: row.category_id,
  });

  setValue("question_hint", row?.question_hint || "");
  setValue("question", row?.question);
  setValue("option_one", row?.option_one);
  setValue("option_two", row?.option_two);
  setValue("option_three", row?.option_three);

  setValue("status", {
    label: row.status ? "Active" : "InActive",
    value: row.status,
  });
};

  useEffect(() => {
    getCategoryDD();
  }, []);
  const getCategoryDD = () => {
    getPrakrityCategoryDDAPI()
      .then((res) => {
        //const status = decrypt(res.data.status);
        if (res.data.status === true) {
          toast.clearWaitingQueue();
          setValue("categoryQuestion", res.data.data);
          setValue("isLoading", false);
        } else if (res.data.status === false) {
          setValue("isLoading", false);
          setValue("categoryQuestion", []);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };
  const onFormSubmit = (data) => {
    const body = {
      category_id: data?.category_question?.value ? data.category_question.value : data.category_question,

      question: data.question,
      question_hint: data.question_hint || "",

      option_one: data.option_one,
      option_two: data.option_two,
      option_three: data.option_three,

      ...(mode === "Edit" && { id :data.selectedRow.id }),
    };

    console.log("API Body:", body);

    if (mode === "Add") {
      createPrakritiQuestionAPI(body)
        .then((res) => {
          if (res.data.status === true) {
            toast.success(res.data.message);
            getPrakrityQuestions();
            setIsOpen(false);
            resetF();
          } else if (res.data.status === "expired") {
            logout();
          } else {
            toast.error(res.data.message);
          }
        })
        .catch((err) => toast.error(err?.response?.data?.message));
      // .finally(() => setIsLoading(false));
    }

    if (mode === "Edit") {
      updatePrakrityQuestionAPI(body)
        .then((res) => {
          if (res.data.status === true) {
            toast.success(res.data.message);
            listPrakrityQuestionsAPI(); 
            getPrakrityQuestions();
            setIsOpen(false);
            resetF();
          } else if (res.data.status === "expired") {
            logout();
          } else {
            toast.error(res.data.message);
          }
        })
        .catch((err) => toast.error(err?.response?.data?.message));
      // .finally(() => setIsLoading(false));
    }
    console.log("data", data,body);
  };
  
  return (
    <>
      <Head title={"Prakrity Question | Master"} />
      <Content>
      
        <Block>
          <div className="container my-5 text-center">
            <Offcanvas backdrop isOpen={isOpen} direction="end" scrollable={false}>
              <OffcanvasHeader toggle={toggleCanvas}>Prakrity Question</OffcanvasHeader>
              <OffcanvasBody>
                <PreviewAltCard>
                  <Form onSubmit={handleSubmit(onFormSubmit)}>
                    <Row>
                      <Col md="12" sm="12" xxl="12">
                        <div className="form-group">
                          <Label className="form-label" htmlFor="question">
                            {"Question"}
                            <Required />
                          </Label>

                          <div className="form-control-wrap">
                            <textarea
                              placeholder={"Enter question"}
                              type="text"
                              id="question"
                              {...register("question", {
                                required: {
                                  value: true,
                                  message: "question is required",
                                },
                                // pattern: {
                                //   value: /^(?!\s*$)[a-zA-Z /.]*$/,
                                //   message: "Only alphabets are allowed",
                                // },
                                minLength: {
                                  value: 3,
                                  message: "question must be at least 2 characters long",
                                },
                                maxLength: {
                                  value: 500,
                                  message: "question cannot exceed 500 characters",
                                },
                              })}
                              className="form-control"
                              value={watch("question")}
                              onChange={(e) => {
                                // let value = e.target.value.replace(/[^A-Za-z\s]/g, ""); // Remove invalid characters
                                // value = value.replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word
                                setValue("question", e.target.value);
                                trigger("question"); // Trigger validation
                              }}
                              // onInput={(e) => {
                              //   e.target.value = e.target.value.replace(/[^A-Za-z\s]/g, "");
                              // }}
                            />
                            {errors.question && <span className="invalid">{errors?.question?.message}</span>}
                          </div>
                        </div>
                      </Col>
                       <Col md="12" sm="12" xxl="12">
                        <div className="form-group mt-2">
                          <Label className="form-label" htmlFor="question_hint">
                            {"Question Hint"} 
                          </Label>

                          <div className="form-control-wrap">
                            <textarea
                              placeholder={"Enter question hint"}
                              type="text"
                              id="question_hint"
                              {...register("question_hint", {
                                required: {
                                  value: false,
                                  message: "question hint is required",
                                },
                                // pattern: {
                                //   value: /^(?!\s*$)[a-zA-Z /.]*$/,
                                //   message: "Only alphabets are allowed",
                                // },
                                minLength: {
                                  value: 3,
                                  message: "question hint must be at least 2 characters long",
                                },
                                maxLength: {
                                  value: 500,
                                  message: "question hint cannot exceed 500 characters",
                                },
                              })}
                              className="form-control"
                              value={watch("question_hint")}
                              onChange={(e) => {
                                // let value = e.target.value.replace(/[^A-Za-z\s]/g, ""); // Remove invalid characters
                                // value = value.replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word
                                setValue("question_hint", e.target.value);
                                trigger("question_hint"); // Trigger validation
                              }}
                              // onInput={(e) => {
                              //   e.target.value = e.target.value.replace(/[^A-Za-z\s]/g, "");
                              // }}
                            />
                            {errors.question_hint && <span className="invalid">{errors?.question_hint?.message}</span>}
                          </div>
                        </div>
                      </Col>
                      {["option_one", "option_two", "option_three"].map((opt, index) => (
                        <React.Fragment key={opt}>
                          <Col md="12 mt-2">
                            <div className="form-group">
                              <Label className="form-label" htmlFor={opt}>
                                {`Option ${index + 1}`}
                              </Label>
                              <div className="form-control-wrap">
                                <input
                                  placeholder={`Enter Option ${index + 1}`}
                                  type="text"
                                  id={opt}
                                  className="form-control"
                                  {...register(opt, {
                                    required: `Option ${index + 1} is required`,
                                    minLength: {
                                      value: 1,
                                      message: "Minimum 1 characters",
                                    },
                                    maxLength: {
                                      value: 500,
                                      message: "Maximum 500 characters",
                                    },
                                  })}
                                  value={watch(opt)}
                                  onChange={(e) => {
                                    setValue(opt, e.target.value);
                                    trigger(opt);
                                  }}
                                />
                                {errors[opt] && <span className="invalid">{errors[opt].message}</span>}
                              </div>
                            </div>
                          </Col>
                        
                        </React.Fragment>
                      ))}
                    </Row>
                    <Col md="12" className={``}>
                      <div className="form-group" style={{ marginTop: "31px" }}>
                        <MyButton isLoading={isLoading} mode={mode} />
                      </div>
                    </Col>
                  </Form>
                </PreviewAltCard>
              </OffcanvasBody>
            </Offcanvas>
          </div>
          <Table 
          title="Prakrity Questions"
          columns={[{key:"question",label:"Question"},{key:"question_hint",label:"Question Hint"},{key:"option_one",label:"Option One"},{key:"option_two",label:"Option Two"},{key:"option_three",label:"Option Three"}]}
          isOpen={isOpen}
          searchKeys={["question"]}
          setIsOpen={setIsOpen}
          resetF={resetF}
          toggleCanvas={toggleCanvas}
          onEditClick={handleEdit}
          data={data}
          />
        </Block>
      </Content>
    </>
  );
};

export default PrakrityQuestion;
